import React, { useState, useEffect, useRef } from "react";
import { FaTrash, FaPlus } from "react-icons/fa";
import Axios from "axios";
import { Modal, Box, TextField, Button, Typography } from "@mui/material";
import { Menu, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { FaRegFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from "@mui/material";
import { isTemp, GROUP_HEADER_COLORS, EFFECT_ITEM_COLOR, overlayStyle, modalStyle, getProjectAndEmail } from "./CloudProCauseeffectshared";
import veloxLogo from "../Assets/icons/newLogo.png";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LOCKED_COLUMN_NAMES = [
  "Common Alarm Indicator & Audible Signal @FACP",
  "Common Trouble Indicator & Audible Signal @FACP",];
const VALUE_ROW_COUNT_FIELDS = ["smoke", "thermal", "smokeTherm", "input", "callPoint"];
const FIELD_LABELS = {
  smoke: "Smoke Detector",
  thermal: "Thermal(Heat) Detector",
  smokeTherm: "Smokethermal (Multi) Detector",
  input: "Input(Monitor) Module",
  callPoint: "Manual Call Point",
  // gas: "Gas Detector",
};
const VALUE_COL_COUNT_FIELDS = ["output", "flasher", "siren", "repLed"];
const COL_FIELD_LABELS = { output: "Output(Control) Module", flasher: "Flasher", siren: "Siren", repLed: "Repeat LED" }
const CloudProMatrixToPanel = ({ maxDelay, setMaxDelay, notify }) => {
  const [causeGroups2, setCauseGroups2] = useState([]);
  const [effectGroups2, setEffectGroups2] = useState([]);
  const displayCols = effectGroups2.flatMap((g) =>
    g.items.length
      ? g.items
      : [{ colId: `${g.colId}-empty`, placeholder: true }]
  );
  const effects2 = effectGroups2.flatMap((g) => g.items);
  const [cellConfig2, setCellConfig2] = useState({});
  const [matrix2Version, setMatrix2Version] = useState(null);

 

  const [syncState2, setSyncState2] = useState("synced");

  const [matrix2GenerationState, setMatrix2GenerationState] = useState(null);
  const [matrix2LocationMap, setMatrix2LocationMap] = useState({});
  const [matrix2DevicePurposeMap, setMatrix2DevicePurposeMap] = useState({});
  const [loading2, setLoading2] = useState(false);
  const [message2, setMessage2] = useState("");
  const [showRowModal2, setShowRowModal2] = useState(false);
  const [rowModal2GroupId, setRowModal2GroupId] = useState(null);
  const [rowModal2Name, setRowModal2Name] = useState("");
  const [editingRowId2, setEditingRowId2] = useState(null);
  const [showColModal2, setShowColModal2] = useState(false);
  const [colModal2GroupId, setColModal2GroupId] = useState(null);
  const [colModal2Name, setColModal2Name] = useState("");
  const [editingColId2, setEditingColId2] = useState(null);
  const [previewResult, setPreviewResult] = useState(null);
  const [showPreviewPanel, setShowPreviewPanel] = useState(false);
  const [previewing, setPreviewing] = useState(false);
  const [applying, setApplying] = useState(false);
  const [applyResult, setApplyResult] = useState(null);
  const [showApplyResultPanel, setShowApplyResultPanel] = useState(false);
  const [causeMenu, setCauseMenu] = useState([]);
  const [rowModal2Type, setRowModal2Type] = useState("");
  const [rowModal2Count, setRowModal2Count] = useState("");
  const [rowModal2Panel, setRowModal2Panel] = useState(1);
  const [rowModal2Zone, setRowModal2Zone] = useState(1);
  const [rowModal2Counts, setRowModal2Counts] = useState(
    Object.fromEntries(VALUE_ROW_COUNT_FIELDS.map((f) => [f, 0]))
  );
  const [colModal2Counts, setColModal2Counts] = useState(
    Object.fromEntries(VALUE_COL_COUNT_FIELDS.map((f) => [f, 0]))
  );
  const [editingColumnGroupId, setEditingColumnGroupId] = useState(null);
  const [showColumnGroupModal, setShowColumnGroupModal] = useState(false);
  const [columnModalName, setColumnModalName] = useState("");
  const openEditColumnGroupModal2 = (id, name) => {
    setEditingColumnGroupId(id);
    setColumnModalName(name);
    setShowColumnGroupModal(true);
  };
  const [editingRowGroupId2, setEditingRowGroupId2] = useState(null);
  const [showRowGroupModal2, setShowRowGroupModal2] = useState(false);
  const openEditRowGroupModal2 = (id, name) => {
    setEditingRowGroupId2(id);
    setRowModal2Name(name);
    setShowRowGroupModal2(true);
  };
  const [selectedCell2, setSelectedCell2] = useState(null);
  const [anchorPosition2, setAnchorPosition2] = useState(null);
  const handleCellRightClick2 = (event, rowId, colId) => {
    event.preventDefault();
    setSelectedCell2({ rowId, colId });
    setAnchorPosition2({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
    });
  };
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [savingProjectInfo, setSavingProjectInfo] = useState(false);
  const [clientName, setClientName] = useState("");
  const [consultantName, setConsultantName] = useState("");
  const [mainContractor, setMainContractor] = useState("");
  const [mepContractor, setMepContractor] = useState("");
  const [faSpecialistContractor, setFaSpecialistContractor] = useState("");
  const tableWrapperRef = useRef(null);
  const [wrapperWidth, setWrapperWidth] = useState(0);
  const [cellConfig, setCellConfig] = useState({});
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const getCellKey2 = (rowId, colId) => `${rowId}__${colId}`;
  const [addRowGroupModal, setAddRowGroupModal] = useState({
    open: false,
    name: "",
    error: "",
  });

  const [addColumnGroupModal, setAddColumnGroupModal] = useState({
    open: false,
    name: "",
    error: "",
  });
  const API = `${BACKEND_URL}/api/cause-effect-workflow`;
  const revisionRef = useRef(null);

  const callWorkflow = async (path, payload = {}) => {
    try {
      const res = await Axios.post(`${API}${path}`, {
        email: localStorage.getItem("userEmail") || "",
        projectId: getProjectId(),
        expectedRevision: revisionRef.current,
        ...payload,
      });
      if (!res.data?.success) {
        notify("error", res.data?.msg || "Request failed");
        return null;
      }
       console.log("✅ API Response:", res.data);
      revisionRef.current = res.data.revision;
      rebuildStateFromCauseEffect2(res.data.matrix);
      return res.data;
    } catch (err) {
      console.error(path, JSON.stringify(err.response?.data, null, 2));
      if (err.response?.status === 409) {
        notify("warning", "Matrix changed elsewhere. Reloading...");
        await loadMatrix2();
      } else {
        notify("error", err.response?.data?.msg || "Server error");
      }
      return null;
    }
  };

  const saveItem = (axis, item) => callWorkflow("/matrix/items/save", { axis, item });
  const setCell = (rowId, columnId, cell) =>
    callWorkflow("/matrix/cells/set", { rowId, columnId, cell });

  const getProjectId = () => {
    const stored = sessionStorage.getItem("selectedProject");
    const p = stored ? JSON.parse(stored) : null;
    return p?.project_id || p?.projectId || null;
  };
  const rebuildStateFromCauseEffect2 = (causeEffect) => {
    if (!causeEffect) return;
    const rows = [...(causeEffect.rows || [])].sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0));
    const cols = [...(causeEffect.cols || [])].sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0));
    const apiCells = causeEffect.cells || {};
    const rowGroupsById = {};
    rows
      .filter((r) => r.kind === "separator")
      .forEach((r) => {
        rowGroupsById[r.id] = {
          group: r.name,
          rowId: r.id,
          sort_key: r.sort_key,
          items: [],
        };
      });
    rows
      .filter((r) => r.kind === "value")
      .forEach((r) => {
        const parentId = r.parentSeparatorId ?? r.parent_separator_id;
        const parent = rowGroupsById[parentId];
        if (parent) {
          parent.items.push({
            name: r.name,
            rowId: r.id,
            counts: r.counts || {},
            meta: r.meta,
            sort_key: r.sort_key,
            selectionPath: r.selectionPath,
            panelNumber: r.panelNumber,
            zoneIndex: r.zoneIndex,
          });
        } else {
          if (!rowGroupsById["__orphan__"]) {
            rowGroupsById["__orphan__"] = { group: "Ungrouped", rowId: "__orphan__", items: [] };
          }
          rowGroupsById["__orphan__"].items.push({
            name: r.name,
            rowId: r.id,
            counts: r.counts || {},
            meta: r.meta,
            sort_key: r.sort_key,
          });
        }
      });
    const groupMap = rows
      .filter((r) => r.kind === "separator")
      .sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0))
      .map((r) => rowGroupsById[r.id]);

    if (rowGroupsById["__orphan__"]) {
      groupMap.push(rowGroupsById["__orphan__"]);
    }
    groupMap.forEach((group) => {
      group.items.sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0));
    });
    const colGroupsById = {};
    cols
      .filter((c) => c.kind === "separator")
      .forEach((c) => {
        colGroupsById[c.id] = { group: c.name, colId: c.id, items: [] };
      });
    cols
      .filter((c) => c.kind === "value")
      .forEach((c) => {
        const locked = LOCKED_COLUMN_NAMES.includes(c.name);
        const parentId = c.parentSeparatorId ?? c.parent_separator_id;
        const parent = colGroupsById[parentId];
        if (parent) {
          parent.items.push({
            name: c.name,
            colId: c.id,
            counts: c.counts || {},
            meta: c.meta,
            locked,
            sort_key: c.sort_key,
            selectionPath: c.selectionPath,
            panelNumber: c.panelNumber,
            zoneIndex: c.zoneIndex,
          });
        } else {
          if (!colGroupsById["__orphan__"]) {
            colGroupsById["__orphan__"] = { group: "Ungrouped", colId: "__orphan__", items: [] };
          }
          colGroupsById["__orphan__"].items.push({
            name: c.name,
            colId: c.id,
            counts: c.counts || {},
            meta: c.meta,
            locked,
            sort_key: c.sort_key,
          });
        }
      });
    const colGroupMap = cols
      .filter((c) => c.kind === "separator")
      .sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0))
      .map((c) => colGroupsById[c.id]);
    colGroupMap.forEach((group) => {
      group.items.sort((a, b) => (a.sort_key || 0) - (b.sort_key || 0));
    });
    if (colGroupsById["__orphan__"]) colGroupMap.push(colGroupsById["__orphan__"]);
    const loadedCellConfig = {};
    Object.entries(apiCells).forEach(([rowId, colMap]) => {
      Object.entries(colMap || {}).forEach(([colId, value]) => {
        if (value) loadedCellConfig[getCellKey2(rowId, colId)] = value;
      });
    });
    setCauseGroups2(groupMap);
    const orderedColGroupMap = [...colGroupMap].sort((a, b) => {
      const aLocked = a.items.some((item) => item.locked);
      const bLocked = b.items.some((item) => item.locked);
      if (aLocked && !bLocked) return -1;
      if (!aLocked && bLocked) return 1;
      return 0;
    });
    setEffectGroups2(orderedColGroupMap);
    setCellConfig2(loadedCellConfig);
  };
 const loadMatrix2 = async () => {
  const projectId = getProjectId();
  if (!projectId) {
    setMessage2("Project not found. Please select a project first.");
    return;
  }
  setLoading2(true);
  try {
    const optionsRes = await Axios.post(`${API}/options`, {
      email: localStorage.getItem("userEmail") || "",
    });
   
    if (optionsRes.data?.success) setCauseMenu(optionsRes.data.causeMenu || []);

    const res = await Axios.post(`${API}/projects/get`, {
      email: localStorage.getItem("userEmail") || "",
      projectId,
    });
   

    if (res.data?.success) {
      revisionRef.current = res.data.revision;
      rebuildStateFromCauseEffect2(res.data.matrix);
      setMessage2("");
    } else {
      setMessage2(res.data?.msg || "Could not load the matrix.");
    }
  } catch (err) {
    console.error("LOAD ERROR:", err.response?.data || err.message);
    notify("error", err.response?.data?.msg || "Server error while loading matrix");
  } finally {
    setLoading2(false);
  }
};

  useEffect(() => {
    loadMatrix2();

  }, []);


  const postMatrix2 = async (endpoint, payload) => {
    const { project, email } = getProjectAndEmail();
    try {
      const res = await Axios.post(`${BACKEND_URL}${endpoint}`, {
        projectId: project?.project_id,
        email,
        expectedVersion: matrix2Version,
        ...payload,
      });
      if (!res.data.success) {
        notify("error", res.data.msg || "Request failed");
        return null;
      }
      if (res.data.syncState) setSyncState2(res.data.syncState);
      if (res.data.locationMap) setMatrix2LocationMap(res.data.locationMap);
      if (res.data.devicePurposeMap) setMatrix2DevicePurposeMap(res.data.devicePurposeMap);
      return res.data;


    } catch (err) {
      if (err.response?.status === 409) {
        notify("warning", err.response?.data?.msg || "Matrix was modified by another user. Reloading the latest version...");
        await loadMatrix2();
        return null;
      }
      console.error(`${endpoint} ERROR:`, err.response?.data || err.message);
      notify("error", err.response?.data?.msg || "Server error");
      return null;
    }
  };
  const MAX_PANEL_NUMBER = 32;
  const MAX_ZONE_INDEX = 192;
const validatePanelNumber = (v) => {
  if (v === "" || v === null || v === undefined) return "Panel number is required";
  const n = Number(v);
  if (!Number.isInteger(n)) return "Must be a whole number";
  if (n < 1 || n > MAX_PANEL_NUMBER) return `Panel number must be 1-${MAX_PANEL_NUMBER}`;
  return "";
};

const validateZoneIndex = (v) => {
  if (v === "" || v === null || v === undefined) return "Zone index is required";
  const n = Number(v);
  if (!Number.isInteger(n)) return "Must be a whole number";
  if (n < 1 || n > MAX_ZONE_INDEX) return `Zone index must be 1-${MAX_ZONE_INDEX}`;
  return "";
};

const rowPanelError = validatePanelNumber(rowModal2Panel);
const rowZoneError = validateZoneIndex(rowModal2Zone);
const submitRowModal2 = async () => {
  if (!rowModal2Name.trim()) {
    notify("warning", "Row name cannot be empty");
    return;
  }

  const panelErr = validatePanelNumber(rowModal2Panel);
  if (panelErr) return notify("warning", panelErr);

  const zoneErr = validateZoneIndex(rowModal2Zone);
  if (zoneErr) return notify("warning", zoneErr);

  const item = {
    kind: "value",
    name: rowModal2Name.trim(),
    selectionPath: [rowModal2Type, rowModal2Count],
    panelNumber: Number(rowModal2Panel),
    zoneIndex: Number(rowModal2Zone),
  };
  if (editingRowId2) item.id = editingRowId2;
  else item.parent_separator_id = rowModal2GroupId;

  const data = await saveItem("row", item);
  if (data) {
    setShowRowModal2(false);
    setEditingRowId2(null);
  }
};
  const addRowGroup2 = () => {
    setAddRowGroupModal({ open: true, name: "", error: "" });
  };

  const confirmAddRowGroup2 = async () => {
    const name = addRowGroupModal.name.trim();
    if (!name) {
      setAddRowGroupModal((prev) => ({ ...prev, error: "Group name cannot be empty" }));
      return;
    }
    const data = await saveItem("row", { name, kind: "separator" });
    if (data) setAddRowGroupModal({ open: false, name: "", error: "" });
  };
  const submitRowGroupModal2 = async () => {
    if (!rowModal2Name.trim()) return notify("warning", "Group name cannot be empty");
    const data = await saveItem("row", { id: editingRowGroupId2, kind: "separator", name: rowModal2Name.trim() });
    if (data) {
      setShowRowGroupModal2(false);
      setEditingRowGroupId2(null);
      setRowModal2Name("");
    }
  };

  const submitColumnGroupModal = async () => {
    if (!columnModalName.trim()) return notify("warning", "Group name cannot be empty");
    const data = await saveItem("column", { id: editingColumnGroupId, kind: "separator", name: columnModalName.trim() });
    if (data) {
      setShowColumnGroupModal(false);
      setEditingColumnGroupId(null);
      setColumnModalName("");
    }
  };

  const addColumnGroup2 = () => {
    setAddColumnGroupModal({ open: true, name: "", error: "" });
  };

  const confirmAddColumnGroup2 = async () => {
    const { name } = addColumnGroupModal;
    if (!name.trim()) {
      setAddColumnGroupModal((prev) => ({ ...prev, error: "Group name cannot be empty" }));
      return;
    }
    try {
      const res = await Axios.post(`${API}/matrix/items/save`, {
        email: localStorage.getItem("userEmail") || "",
        projectId: getProjectId(),
        expectedRevision: revisionRef.current,
        axis: "column",
        item: { name: name.trim(), kind: "separator" },
      });
      if (res.data?.success) {
        revisionRef.current = res.data.revision;
        rebuildStateFromCauseEffect2(res.data.matrix);
        setAddColumnGroupModal({ open: false, name: "", error: "" });
      }
    } catch (err) {
      setAddColumnGroupModal((prev) => ({
        ...prev,
        error: err.response?.data?.msg || "Failed to add group",
      }));
    }
  };
  const openAddRowModal2 = (groupId, defaultName) => {
    setEditingRowId2(null);
    setRowModal2GroupId(groupId);
    setRowModal2Name(defaultName || "");
    setRowModal2Type("");
    setRowModal2Count("");
    setRowModal2Panel(1);
    setRowModal2Zone(1);
    setShowRowModal2(true);
  };

  const openAddColumnModal2 = (groupId, defaultName) => {
    setEditingColId2(null);
    setColModal2GroupId(groupId);
    setColModal2Name(defaultName || "");
    setColModal2Counts(Object.fromEntries(VALUE_COL_COUNT_FIELDS.map((f) => [f, 0])));
    setShowColModal2(true);
  };

const submitColModal2 = async () => {
  if (!colModal2Name.trim()) {
    notify("warning", "Column name cannot be empty");
    return;
  }

  const item = { kind: "value", name: colModal2Name.trim() };
  if (editingColId2) item.id = editingColId2;
  else item.parent_separator_id = colModal2GroupId;

  const data = await saveItem("column", item);
  if (data) {
    setShowColModal2(false);
    setEditingColId2(null);
  }
};

  const [pendingCellKey, setPendingCellKey] = useState(null);

  const cycleCell2 = async (rowId, colId, currentCell) => {
    const key = getCellKey2(rowId, colId);
    if (pendingCellKey === key) return;
    setPendingCellKey(key);
    await setCell(rowId, colId, currentCell ? null : { delaySeconds: 0, outputZones: [] });
    setPendingCellKey(null);
  };
 
const MAX_OUTPUT_ZONE = 255;


const validateZonesText = (text) => {
  const t = String(text || "").trim();
  if (!t) return "";

  for (const raw of t.split(",")) {
    const part = raw.trim();
    if (!part) continue;

    const m = part.match(/^(\d+)(?:\s*-\s*(\d+))?$/);
    if (!m) return "Use numbers like 1,2,5-8";

    const a = Number(m[1]);
    const b = m[2] !== undefined ? Number(m[2]) : a;

    if (a < 1 || b < 1) return "Output zones start at 1";
    if (a > MAX_OUTPUT_ZONE || b > MAX_OUTPUT_ZONE)
      return `Output zone cannot be greater than ${MAX_OUTPUT_ZONE}`;
    if (b < a) return `Invalid range ${a}-${b}`;
  }
  return "";
};
const parseZoneText = (text) => {
  const out = new Set();
  for (const part of String(text).split(",").map((s) => s.trim()).filter(Boolean)) {
    const m = part.match(/^(\d+)(?:\s*-\s*(\d+))?$/);
    if (!m) return null;
    const a = Number(m[1]);
    const b = m[2] ? Number(m[2]) : a;
    if (a < 1 || b > MAX_OUTPUT_ZONE || b < a) return null;
    for (let n = a; n <= b; n++) out.add(n);
  }
  return [...out].sort((x, y) => x - y);
};

const compressZones = (list) => {
  const s = [...new Set(list)].sort((a, b) => a - b);
  const parts = [];
  for (let i = 0; i < s.length; ) {
    let j = i;
    while (j + 1 < s.length && s[j + 1] === s[j] + 1) j++;
    parts.push(j > i ? `${s[i]}-${s[j]}` : `${s[i]}`);
    i = j + 1;
  }
  return parts.join(",");
};

const zonesToGroups = (zones = []) => {
  const byPanel = {};
  zones.forEach((z) => (byPanel[z.panelNumber] ||= []).push(z.outputZoneIndex));
  return Object.entries(byPanel).map(([p, list]) => ({
    panelNumber: Number(p),
    zonesText: compressZones(list),
  }));
};
const [cellDialog, setCellDialog] = useState({
  open: false, rowId: null, colId: null, delay: 0, groups: [],
});

const openCellDialog = (rowId, colId, existing) => {
  setCellDialog({
    open: true,
    rowId,
    colId,
    delay: existing?.delaySeconds ?? 0,
    groups: zonesToGroups(existing?.outputZones),
  });
};

const updateGroup = (i, field, value) =>
  setCellDialog((p) => ({
    ...p,
    groups: p.groups.map((g, idx) => (idx === i ? { ...g, [field]: value } : g)),
  }));

const addZone = () =>
  setCellDialog((p) => ({ ...p, groups: [...p.groups, { panelNumber: 1, zonesText: "" }] }));

const removeZone = (i) =>
  setCellDialog((p) => ({ ...p, groups: p.groups.filter((_, idx) => idx !== i) }));
const closeCellDialog = () => setCellDialog((p) => ({ ...p, open: false }))
 const saveCellDialog = async () => {
  const { rowId, colId, delay, groups } = cellDialog;
  const delaySeconds = Number(delay);
  if (!Number.isInteger(delaySeconds) || delaySeconds < 0) {
    notify("warning", "Delay must be 0 or more seconds");
    return;
  }

  const seen = new Set();
  const cleaned = [];
  for (const g of groups) {
    const panelNumber = Number(g.panelNumber);
    const list = parseZoneText(g.zonesText);
    if (!Number.isInteger(panelNumber) || panelNumber < 1 || panelNumber > 32) {
      notify("warning", "Panel must be 1-32");
      return;
    }
    if (!list || list.some((n) => n < 1 || n > 255)) {
      notify("warning", `Invalid output zones for Panel ${panelNumber}. Use 1-255, e.g. 1,2,5-8`);
      return;
    }
    list.forEach((outputZoneIndex) => {
      const k = `${panelNumber}-${outputZoneIndex}`;
      if (!seen.has(k)) {
        seen.add(k);
        cleaned.push({ panelNumber, outputZoneIndex });
      }
    });
  }

  const data = await setCell(rowId, colId, { delaySeconds, outputZones: cleaned });
  if (data) closeCellDialog();
};

  const clearCellFromDialog = async () => {
    const data = await setCell(cellDialog.rowId, cellDialog.colId, null);
    if (data) closeCellDialog();
  };
  const previewGeneration = async () => {
    const { project, email } = getProjectAndEmail();
    setPreviewing(true);
    try {
      const res = await Axios.post(`${BACKEND_URL}/preview_cause_effect_to_panels`, {
        projectId: project?.project_id,
        email,
        expectedVersion: matrix2Version,
      });
      if (res.data.success) {
        if (res.data.version !== undefined) setMatrix2Version(res.data.version);
        if (res.data.syncState) setSyncState2(res.data.syncState);
        setPreviewResult(res.data);
        setShowPreviewPanel(true);
      } else {
        notify("error", res.data.msg || "Preview failed");
      }
    } catch (err) {
      if (err.response?.status === 409) {
        notify("warning", "Matrix was modified by another user. Reloading the latest version...");
        await loadMatrix2();
      } else {
        console.error("PREVIEW ERROR:", err.response?.data || err.message);
        notify("error", err.response?.data?.msg || "Server error while previewing generation");
      }
    } finally {
      setPreviewing(false);
    }
  };
  const [applyDialogOpen, setApplyDialogOpen] = useState(false);
  const confirmApplyGeneration = async () => {
    const { project, email } = getProjectAndEmail();
    setApplying(true);

    try {
      const res = await Axios.post(`${BACKEND_URL}/apply_cause_effect_to_panels`, {
        projectId: project?.project_id,
        email,
        expectedVersion: matrix2Version,
      });

      if (res.data.success) {
        setApplyResult(res.data);
        setShowApplyResultPanel(true);
        setShowPreviewPanel(false);

        await loadMatrix2();

        rebuildStateFromCauseEffect2(res.data.cause_effect);
        setMatrix2GenerationState(res.data.generationState || null);

        if (res.data.version !== undefined)
          setMatrix2Version(res.data.version);
        if (res.data.syncState) setSyncState2(res.data.syncState);

        sessionStorage.removeItem("panelContentId");
        sessionStorage.removeItem("panelDeviceId");

        notify(
          "success",
          `Generated ${res.data.insertedNewPanelCount} new panel(s).`
        );
      } else {
        notify("error", res.data.msg || "Apply failed");
      }
    } catch (err) {
      if (err.response?.status === 409) {
        notify(
          "warning",
          "Matrix was modified by another user. Reloading the latest version..."
        );
        await loadMatrix2();
      } else {
        console.error("APPLY ERROR:", err.response?.data || err.message);
        notify(
          "error",
          err.response?.data?.msg ||
          "Server error while applying generation"
        );
      }
    } finally {
      setApplying(false);
      setApplyDialogOpen(false);
    }
  };
  const applyGeneration = () => {
    setApplyDialogOpen(true);
  };

  const openEditRowModal2 = (row) => {
    setEditingRowId2(row.rowId);
    setRowModal2Name(row.name);
    setRowModal2Type((row.selectionPath || [])[0] || "");
    setRowModal2Count((row.selectionPath || [])[1] || "");
    setRowModal2Panel(row.panelNumber ?? 1);
    setRowModal2Zone(row.zoneIndex ?? 1);
    setShowRowModal2(true);
  };

const openEditColModal2 = (col) => {
  setEditingColId2(col.colId);
  setColModal2Name(col.name);
  setShowColModal2(true);
};
  // For add project Info

  const openProjectInfoPopup = async () => {
    if (await getProjectInfo()) setShowInfoPopup(true);
  };

  const getProjectInfo = async () => {
    try {
      const email = localStorage.getItem("userEmail") || "";
      const stored = sessionStorage.getItem("selectedProject");
      const project = stored ? JSON.parse(stored) : null;

      if (!project?.project_id) throw new Error("No project selected.");

      const response = await Axios.post(
        `${BACKEND_URL}/get_cause_effect_project_info`,
        {
          email,
          projectId: project.project_id,
        }
      );

    

      if (!response.data?.success) throw new Error(response.data?.msg || "Unable to load project information.");
      const info = response.data.projectInfo || [];
      setClientName(info[0] || "");
      setConsultantName(info[1] || "");
      setMainContractor(info[2] || "");
      setMepContractor(info[3] || "");
      setFaSpecialistContractor(info[4] || "");
      return true;
    } catch (err) {
      console.error("Get project info error:", err);
      notify("error", err.response?.data?.msg || err.message || "Unable to load project information.");
      return false;
    }
  };

  const updateProjectInfo = async (type, newValue) => {
      const userEmail = localStorage.getItem("userEmail");
      const stored = sessionStorage.getItem("selectedProject");
      const project = stored ? JSON.parse(stored) : null;

      const response = await Axios.post(`${BACKEND_URL}/set_cause_effect_project_info`, {
        email: userEmail,
        projectId: project.project_id,
        type,
        newValue,
      });

      if (!response.data?.success) throw new Error(response.data?.msg || "Unable to save project information.");
      return response.data.projectInfo;
  };

  const handleSaveProjectInfo = async () => {
    if (savingProjectInfo) return;
    setSavingProjectInfo(true);
    try {
      const values = [clientName, consultantName, mainContractor, mepContractor, faSpecialistContractor];
      for (let type = 0; type < values.length; type++) {
        await updateProjectInfo(type, values[type]);
      }
      notify("success", "Project information saved successfully.");
      setShowInfoPopup(false);
    } catch (err) {
      console.error("Save project info error:", err);
      notify("error", err.response?.data?.msg || err.message || "Unable to save project information.");
    } finally {
      setSavingProjectInfo(false);
    }
  };

  // for export PDF 

  const getBase64FromUrl = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  const hexToRgb = (hex) => {
    const clean = hex.replace("#", "").slice(0, 6);
    const num = parseInt(clean, 16);
    return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
  };

  const CAUSE_GROUP_COLOR = hexToRgb("#EC5800");
  const CAUSE_GROUP_COLOR1 = hexToRgb("#d40007");
  const CAUSE_CELL_COLOR = hexToRgb("#dbe5f1");
  const CORNER_COLOR = hexToRgb("#ffc000");
  const DELAY_COLOR = hexToRgb("#F28C28");
  const IMMEDIATE_COLOR = [255, 0, 0];
  const CELLTYPE_COLOR = hexToRgb("#0b6708");
  const drawCenteredLabelValuePairs = (doc, pairs, y, pageWidth, gap = 4) => {

    let totalWidth = 0;
    const measurements = pairs.map(({ label, value }) => {
      doc.setFont("helvetica", "bold");
      const labelWidth = doc.getTextWidth(label + " ");
      doc.setFont("helvetica", "normal");
      const valueWidth = doc.getTextWidth(value);
      const pairWidth = labelWidth + valueWidth;
      totalWidth += pairWidth;
      return { label, value, labelWidth, valueWidth };
    });
    totalWidth += gap * (pairs.length - 1);


    let x = (pageWidth - totalWidth) / 2;
    measurements.forEach(({ label, value, labelWidth, valueWidth }) => {
      doc.setFont("helvetica", "bold");
      doc.text(label + " ", x, y);
      x += labelWidth;

      doc.setFont("helvetica", "normal");
      doc.text(value, x, y);
      x += valueWidth + gap;
    });
  };
  const exportPDF = async () => {
    const storedProject = JSON.parse(sessionStorage.getItem("selectedProject"));
    const projectName = storedProject?.name || "Project";
    const companyName = storedProject?.companyName || storedProject?.company_name || "Velox Life Safety Inc.";

    let logoBase64 = null;
    try {
      logoBase64 = await getBase64FromUrl(veloxLogo);
    } catch (err) {
      console.warn("Logo load failed:", err);
    }

    const valueRows = [];
    causeGroups2.forEach((group) => {
      group.items.forEach((item) => valueRows.push({ rowId: item.rowId }));
    });

    const getCellDisplay = (item, colId) => {
      const key = getCellKey2(item.rowId, colId);
      const delay = cellConfig2[key]?.delaySeconds;
      if (delay === undefined) return { text: "", color: [0, 0, 0] };
      if (delay === 0) return { text: "•", color: IMMEDIATE_COLOR };
      return { text: `D${delay}`, color: DELAY_COLOR };
    };
    const GROUP_HEADER_PDF_COLORS = GROUP_HEADER_COLORS.map(hexToRgb);
    const EFFECT_ITEM_PDF_COLOR = hexToRgb(EFFECT_ITEM_COLOR);
    const flatEffects = [];
    effectGroups2.forEach((group, gi) => {
      const groupColor = GROUP_HEADER_PDF_COLORS[gi % GROUP_HEADER_PDF_COLORS.length];
      if (group.items.length === 0) {
        flatEffects.push({
          colId: `${group.colId}-empty`,
          name: "",
          groupName: group.group,
          groupColor,
          isEmptyPlaceholder: true,
        });
      } else {
        group.items.forEach((item) => {
          flatEffects.push({ ...item, groupName: group.group, groupColor });
        });
      }
    });

    const totalEffects = flatEffects.length;
    const totalDataRows = causeGroups2.reduce((sum, g) => sum + 1 + g.items.length, 0);

    const longestCauseName = causeGroups2.reduce(
      (max, g) => Math.max(max, g.group.length, ...g.items.map((i) => i.name.length)),
      0
    );

    const margin = 10;
    const labelColWidth = Math.min(70, Math.max(35, longestCauseName * 1.8));
    const minEffectColWidth = 10;
    const minBodyRowHeight = 4;
    const letterheadHeight = 45;
    const footerHeight = 12;

    const pageSizes = [
      { format: "a4", width: 297, height: 210 },
      { format: "a3", width: 420, height: 297 },
      { format: "a2", width: 594, height: 420 },
      { format: "a1", width: 841, height: 594 },
    ];

    const requiredWidth = labelColWidth + Math.max(totalEffects, 1) * minEffectColWidth + margin * 2;
    const requiredHeight = letterheadHeight + totalDataRows * minBodyRowHeight + footerHeight + margin * 2;

    const chosenPage =
      pageSizes.find((p) => p.width >= requiredWidth && p.height >= requiredHeight) ||
      pageSizes[pageSizes.length - 1];

    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: chosenPage.format });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const usableWidth = pageWidth - margin * 2;

    const idealColWidth = totalEffects > 0 ? Math.floor((usableWidth - labelColWidth) / totalEffects) : 15;
    const effectColWidthPdf = Math.min(15, Math.max(minEffectColWidth, idealColWidth));

    const colsPerPage = Math.max(1, Math.floor((usableWidth - labelColWidth) / effectColWidthPdf));

    const longestEffectName = flatEffects.reduce((max, e) => Math.max(max, (e.name || "").length), 0);
    const headerRowHeight = Math.min(35, Math.max(14, longestEffectName * 1.3));

    const isRowDense = totalDataRows > 50;
    const headerFontSize = effectColWidthPdf < 8 ? 4.5 : isRowDense ? 5 : 5.5;
    const bodyFontSize = effectColWidthPdf < 8 ? 5 : isRowDense ? 5.5 : 6;

    const effectChunks = [];
    if (totalEffects === 0) {
      effectChunks.push([]);
    } else {
      for (let i = 0; i < flatEffects.length; i += colsPerPage) {
        effectChunks.push(flatEffects.slice(i, i + colsPerPage));
      }
    }

    const companyAddress = "27 Terracon Place, Winnipeg, Manitoba, R2J 4B3, Canada";
    const companyWebsite = "https://velox.ca/";
    const companyEmail = "info@velox.ca";

    const drawHeader = ({ lightweight = false } = {}) => {
      let infoY = 20;
      if (logoBase64) doc.addImage(logoBase64, "PNG", margin, 4, 28, 14);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(...CAUSE_GROUP_COLOR1);
      doc.text(companyName, pageWidth / 2, 10, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.setTextColor(80);
      const addressLines = doc.splitTextToSize(companyAddress, 120);
      doc.text(addressLines, pageWidth / 2, 14, { align: "center" });

      // Website + Email on ONE line
      doc.setFontSize(7);
      doc.setTextColor(0, 0, 0);
      const contactY = 18;
      drawCenteredLabelValuePairs(
        doc,
        [
          { label: "Website:", value: companyWebsite },
          { label: "Email:", value: companyEmail },
        ],
        contactY,
        pageWidth
      );

      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(...CAUSE_GROUP_COLOR);
      const titleY = 17 + addressLines.length * 4 + 3;
      doc.text(lightweight ? "Cause & Effect Matrix (continued)" : "Cause & Effect Matrix", pageWidth / 2, titleY, {
        align: "center",
      });

      if (!lightweight) {
        doc.setTextColor(0, 0, 0);
        let rightY = 10;
        const startX = pageWidth - 50;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(7);
        doc.text("Project:", startX, rightY);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(7);
        doc.text(projectName, startX + doc.getTextWidth("Project:") + 2, rightY);
        rightY += 5;


      }

      doc.setDrawColor(...CAUSE_GROUP_COLOR);
      doc.line(margin, infoY, pageWidth - margin, infoY);
      return infoY;
    };

    const buildGroupRuns = (chunkEffects) => {
      const runs = [];
      chunkEffects.forEach((effect) => {
        const last = runs[runs.length - 1];
        if (last && last.groupName === effect.groupName) {
          last.count += 1;
        } else {
          runs.push({ groupName: effect.groupName, groupColor: effect.groupColor, count: 1 });
        }
      });
      return runs;
    };

    effectChunks.forEach((chunkEffects, chunkIndex) => {
      if (chunkIndex > 0) doc.addPage();

      const chunkStartIndex = chunkIndex * colsPerPage;
      drawHeader({ lightweight: false });
      const chunkFirstPage = doc.internal.getNumberOfPages();
      if (effectChunks.length > 1) {
        doc.setFontSize(9);
        doc.setTextColor(0);
        doc.text(
          `Effects ${chunkStartIndex + 1}–${chunkStartIndex + chunkEffects.length} of ${flatEffects.length}`,
          pageWidth - margin,
          25,
          { align: "right" }
        );
      }

      autoTable(doc, {
        startY: 28,
        theme: "grid",
        head: [["Client Name", "Consultant", "Main Contractor", "MEP Contractor", "FA Specialist Contractor"]],
        body: [[clientName, consultantName, mainContractor, mepContractor, faSpecialistContractor]],
        styles: { fontSize: 8, halign: "center" },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: [150, 150, 150],
          lineWidth: 0.1,
        },
      });

      const groupRuns = buildGroupRuns(chunkEffects);

      const groupHeaderRow = [
        {
          content: "Cause / Effect",
          rowSpan: 2,
          styles: {
            fillColor: CORNER_COLOR,
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            fontSize: bodyFontSize,
          },
        },
        ...groupRuns.map((run) => ({
          content: run.groupName,
          colSpan: run.count,
          styles: {
            fillColor: run.groupColor,
            textColor: [0, 0, 0],
            halign: "center",
            valign: "middle",
            fontStyle: "bold",
            fontSize: bodyFontSize,
            minCellHeight: 8,
          },
        })),
      ];

      const effectNameRow = chunkEffects.map(() => "");

      const headers = [groupHeaderRow, effectNameRow];

      const columnStyles = { 0: { cellWidth: labelColWidth } };
      chunkEffects.forEach((_, i) => {
        columnStyles[i + 1] = { cellWidth: effectColWidthPdf, halign: "center" };
      });

      const rows = [];
      causeGroups2.forEach((group) => {
        rows.push([
          {
            content: group.group,
            styles: {
              fontStyle: "bold",
              fillColor: CAUSE_GROUP_COLOR,
              textColor: [0, 0, 0],
              halign: "left",
              fontSize: bodyFontSize,
            },
          },
          ...chunkEffects.map(() => ({
            content: "",
            styles: {
              fillColor: [233, 239, 204],
              lineColor: [150, 150, 150],
              lineWidth: 0.1,
            },
          })),
        ]);

        group.items.forEach((item) => {
          const row = [{ content: item.name, styles: { fillColor: CAUSE_CELL_COLOR, halign: "left" } }];
          chunkEffects.forEach((effect) => {
            const { text, color } = getCellDisplay(item, effect.colId);

            row.push({
              content: text,
              styles: {
                textColor: color,
                fontStyle: "bold",
              },
            });
          });
          rows.push(row);
        });
      });

      autoTable(doc, {
        theme: "grid",
        head: headers,
        body: rows,
        startY: doc.lastAutoTable.finalY + 8,
        margin: { left: margin, right: margin, top: 28 },
        columnStyles,
        styles: {
          fontSize: bodyFontSize,
          cellPadding: 1,
          overflow: "hidden",
          minCellHeight: minBodyRowHeight,
          lineWidth: 0.1,
          lineColor: [150, 150, 150],
          fillColor: [233, 239, 204],
        },
        headStyles: {
          fillColor: CORNER_COLOR,
          textColor: [0, 0, 0],
          cellPadding: 1,
          minCellHeight: headerRowHeight,
          overflow: "visible",
          fontSize: bodyFontSize,
          halign: "center",
          valign: "middle",
          lineWidth: 0.1,
          lineColor: [150, 150, 150],
        },
        didDrawCell: (data) => {
          if (data.section === "head" && data.row.index === 1 && data.column.index > 0) {
            const { x, y, width, height } = data.cell;
            const effect = chunkEffects[data.column.index - 1];
            const effectName = effect?.name || "";
            const cellColor = EFFECT_ITEM_PDF_COLOR;

            doc.setFillColor(...cellColor);
            doc.rect(x, y, width, height, "F");

            doc.setDrawColor(150, 150, 150);
            doc.setLineWidth(0.1);
            doc.rect(x, y, width, height, "S");

            if (effectName) {

              doc.setFontSize(headerFontSize);
              doc.setTextColor(0, 0, 0);
              doc.text(effectName, x + width / 4, y + height - 1, {
                angle: 90,
                align: "left",
                maxWidth: height - 1.5,
              });
            }
          }
        },
        didDrawPage: (data) => {
          if (data.pageNumber > chunkFirstPage) drawHeader({ lightweight: true });
        },
      });

      const finalY = doc.lastAutoTable.finalY || 30;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.setTextColor(255, 0, 0);
      const legendStartX = margin + 15;
      const legendMaxX = pageWidth - margin;
      const lineHeight = 4;
      let legendX = legendStartX;
      let legendY = finalY + 8;
      const gap = 6;

      const drawLegendEntry = (symbol, label, symbolColor) => {
        const symbolWidth = doc.getTextWidth(symbol);
        const labelWidth = doc.getTextWidth(label);
        const entryWidth = symbolWidth + labelWidth + gap;

        if (legendX + entryWidth > legendMaxX) {
          legendX = legendStartX;
          legendY += lineHeight;
        }

        doc.setTextColor(...symbolColor);
        doc.setFont("helvetica", "normal");
        doc.text(symbol, legendX, legendY);
        legendX += symbolWidth;

        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.text(label, legendX, legendY);
        legendX += labelWidth + gap;
      };

      const usedDelayValues = new Set();
      let hasImmediateAlarm = false;

      causeGroups2.forEach((group) => {
        group.items.forEach((item) => {
          chunkEffects.forEach((effect) => {
            const key = getCellKey2(item.rowId, effect.colId);
            const delay = cellConfig2[key]?.delaySeconds;

            if (delay === 0) {
              hasImmediateAlarm = true;
            } else if (delay > 0) {
              usedDelayValues.add(delay);
            }
          });
        });
      });

      if (hasImmediateAlarm) {
        drawLegendEntry("•", " = Immediate Alarm", IMMEDIATE_COLOR);
      }


      Array.from(usedDelayValues)
        .sort((a, b) => a - b)
        .forEach((delay) => {
          drawLegendEntry(
            `D${delay}`,
            ` = Delay ${delay} Seconds`,
            DELAY_COLOR
          );
        });

      doc.setFontSize(7);
      doc.setTextColor(150);
      doc.text(`Page ${chunkIndex + 1} of ${effectChunks.length}`, pageWidth - margin, pageHeight - 5, {
        align: "right",
      });
    });

    doc.save(`${projectName} cause-effect-table.pdf`);
  };

  // delete functionality 
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    itemId: null,
    isLocked: false,
    title: "",
    message: "",
    axisType: null,
  });

  const deleteItem2 = (itemId, isLocked = false, type = "item") => {
    if (isLocked) {
      notify("warning", "This is a locked system column and cannot be deleted.");
      return;
    }

    let title = "Delete";
    let message = "Are you sure?";
    let axisType = "row";

    switch (type) {
      case "causeGroup":
        title = "Delete Cause Group";
        message =
          "Delete this item? Deleting a group will also delete its children.";
        axisType = "row";
        break;

      case "cause":
        title = "Delete Cause";
        message = "Are you sure you want to delete this cause?";
        axisType = "row";
        break;

      case "effectGroup":
        title = "Delete Effect Group";
        message =
          "Delete this item? Deleting a group will also delete its children.";
        axisType = "column";
        break;

      case "effect":
        title = "Delete Effect";
        message = "Are you sure you want to delete this effect?";
        axisType = "column";
        break;

      default:
        break;
    }

    setDeleteDialog({
      open: true,
      itemId,
      isLocked,
      title,
      message,
      axisType,
    });
  };
  const confirmDelete = async () => {
    await callWorkflow("/matrix/items/delete", {
      axis: deleteDialog.axisType,
      itemId: deleteDialog.itemId,
    });
    setDeleteDialog({ open: false, itemId: null, isLocked: false, title: "", message: "", axisType: null });
  };
  const cellDialogHasError = cellDialog.groups.some((g) => {
  const n = Number(g.panelNumber);
  return (
    Boolean(validateZonesText(g.zonesText)) ||
    !Number.isInteger(n) || n < 1 || n > 32
  );
});
  return (
    <>
      <div style={{ margin: "10px 10px" }}>
        {loading2 ? (
          <div style={{ fontSize: "14px", color: "#444" }}>⏳ Loading matrix...</div>
        ) : causeGroups2.length === 0 && effectGroups2.length === 0 ? (
          <div
            style={{
              fontSize: "15px",
              border: "1px dashed #ccc",
              borderRadius: "8px",
              textAlign: "center",
              color: "red",
              width: "100%",
              padding: "10px",
            }}
          >
            No matrix data yet. Click <strong>"Add Cause Group"</strong> to create your first cause group and{" "}
            <strong>"Add Effect Group"</strong> to create your effect group, then use the{" "}
            <FaPlus style={{ verticalAlign: "middle" }} /> icons to add rows and columns underneath.
          </div>
        ) : (
          message2 && <h6 style={{ fontSize: "15px" }}>{message2}</h6>
        )}
        {syncState2 === "conflict" && (
          <div
            style={{
              fontSize: "12px",
              color: "#8a6d00",
              background: "#fff8e1",
              border: "1px solid #F4C430",
              borderRadius: "6px",
              padding: "6px 10px",
              marginTop: "6px",
            }}
          >
            The Matrix and Panel have both changed since the last sync. Review before compiling to avoid overwriting
            either side.
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "5px",
          marginLeft: "10px",
          marginRight: "10px",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <button onClick={addRowGroup2} className="btn csv">
            Add Cause Group
          </button>
          <button onClick={addColumnGroup2} className="btn csv">
            Add Effect Group
          </button>

          <button onClick={openProjectInfoPopup} className="btn add">
            Add Info
          </button>
          {/*
            Old bulk "Save" button removed — row/column/count/cell changes
            are now saved immediately through their individual Matrix APIs
            (postMatrix2 / cycleCell2), so a separate save step isn't needed.
          */}
          {/* <button onClick={previewGeneration} className="btn csv" disabled={previewing}>
            {previewing ? "Previewing..." : "Preview"}
          </button> */}
          {/* <button onClick={applyGeneration} className="btn pdf" disabled={applying}>
            {applying ? "Applying..." : "Compile"}
          </button> */}
          {/* {matrix2Version !== null && <span style={{ fontSize: "12px", color: "#666" }}>Version: {matrix2Version}</span>} */}
          <button onClick={exportPDF} className="btn pdf">
            <FaRegFilePdf /> PDF
          </button>
          <div
            style={{

              borderRadius: "6px",

              display: "flex",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            {/* <button className="btn csv" onClick={handleOpen}>
              Delay
            </button> */}

           
            <Modal open={open} onClose={handleClose}>
              <Box
                sx={{
                  p: 3,
                  width: "20%",
                  fontSize:"12px",
                  bgcolor: "white",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  borderRadius: 2,
                }}
              >
               <TextField
  label="Maximum Delay (Seconds)"
  type="number"
  size="small"
  inputProps={{ min: 30, max: 300, step: 30 }}
  value={maxDelay}
  onChange={(e) => {
    const value = Number(e.target.value);
    if (value <= 300) {
      setMaxDelay(value || 0);
    }
  }}
  sx={{ mb: 2, width: 180 }}
/>

                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  <span>
                  <strong style={{ color: "red" }}>•</strong> Immediate Alarm
                  </span>

                 {Array.from({ length: Math.floor(maxDelay / 30) }, (_, i) => {
  const seconds = (i + 1) * 30;
  return (
    <span key={seconds}>
      <strong style={{ color: "#F28C28" }}>D{seconds}</strong> - {seconds} sec delay
    </span>
  );
})}
                </div>
              </Box>
            </Modal>

          </div>
        </div>

      </div>
      {!loading2 && (causeGroups2.length > 0 || effectGroups2.length > 0) && (
        <div className="ce-table-wrapper">
          <table className="ce-matrix-table">
            <thead>
              <tr>
                <th rowSpan={2} className="corner-cell" style={{ "--corner-w": "160px", "--corner-h": "70px" }}>
                  <span className="effect-label">EFFECT</span>
                  <span className="cause-label">CAUSE</span>
                </th>
                {effectGroups2.map((group, gi) => (
                  <th
                    key={group.colId}
                    colSpan={Math.max(group.items.length, 1)}
                    className="effect-group-header"
                    style={{ background: GROUP_HEADER_COLORS[gi % GROUP_HEADER_COLORS.length] }}
                  >
                    <div
                      className="group-header-content"
                      onDoubleClick={(e) => {
                        e.stopPropagation();
                        openEditColumnGroupModal2(group.colId, group.group);
                      }}
                    >
                      <span>{group.group}</span>

                      {!group.items.some((item) => item.locked) && (
                        <div className="header-actions">
                          <FaPlus
                            style={{ cursor: "pointer", fontSize: "11px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              openAddColumnModal2(group.colId, `C${group.items.length + 1}`);
                            }}
                          />
                          <FaTrash
                            style={{ cursor: "pointer", fontSize: "11px", color: "black" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteItem2(group.colId, false, "effectGroup");
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
              <tr>
                {effectGroups2.map((group, gi) =>
                  group.items.length > 0 ? (
                    group.items.map((col) => (
                      <th
                        key={col.colId}
                        className="effect-col-header"
                        onDoubleClick={() => openEditColModal2(col)}
                        style={{ background: EFFECT_ITEM_COLOR }}
                      >
                        <span className="vertical-text" title={col.name} style={{ fontSize: "11px" }}>
                          <span className="effect-name-text">
                            {col.locked ? "🔒 " : ""}
                            {col.name}
                            {!col.locked && (
                              <FaTrash
                                className="delete-icon"
                                style={{ cursor: "pointer", fontSize: "10px", transform: "rotate(90deg)" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteItem2(col.colId, col.locked, "effect");
                                }}
                              />
                            )}
                          </span>
                        </span>
                      </th>
                    ))
                  ) : (
                    <th
                      key={`${group.colId}-empty`}
                      className="effect-col-header"
                      onClick={() => openAddColumnModal2(group.colId, "C1")}
                      title="Click to add the first column in this group"
                    >
                      <span style={{ fontSize: "10px", cursor: "pointer" }}>
                        <FaPlus />
                      </span>

                    </th>

                  )
                )}
              </tr>
            </thead>
            <tbody>
              {causeGroups2.map((group) => (
                <React.Fragment key={group.rowId}>
                  <tr className="cause-group-row">
                    <td
                      className="sticky-col cause-group-title"
                      onDoubleClick={() => openEditRowGroupModal2(group.rowId, group.group)}
                    >
                      <div className="hover-container">
                        <strong>{group.group}</strong>
                        <FaTrash
                          className="delete-icon"
                          style={{ cursor: "pointer", fontSize: "11px" }}
                          onClick={() => deleteItem2(group.rowId, false, "causeGroup")}
                        />
                        <FaPlus
                          style={{ cursor: "pointer", fontSize: "11px" }}
                          onClick={() => openAddRowModal2(group.rowId, `R${group.items.length + 1}`)}
                        />
                      </div>
                    </td>
                    {displayCols.map((col) => (
                      <td key={col.colId} className="cause-group-fill"></td>
                    ))}
                  </tr>
                  {group.items.map((row) => (
                    <tr key={row.rowId}>
                      <td className="cause-cell sticky-col" onDoubleClick={() => openEditRowModal2(row)}>
                        <div className="hover-container">
                          <span>{row.name}</span>
                          <FaTrash className="delete-icon" onClick={() => deleteItem2(row.rowId, false, "cause")} />
                        </div>
                      </td>
                      {displayCols.map((col) => {
                        if (col.placeholder) return <td key={col.colId} className="matrix-cell" />;

                        const key = getCellKey2(row.rowId, col.colId);
                        const val = cellConfig2[key];
                        const delay = val?.delaySeconds;
                        const zones = val?.outputZones || [];
                        const zonesTitle = zones.map((z) => `P${z.panelNumber}-OZ${z.outputZoneIndex}`).join(", ");

                        let display = null;
                        if (val) {
                          display = (
                            <div style={{ lineHeight: 1.1, textAlign: "center" }}>
                              {delay === 0 ? (
                                <span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>•</span>
                              ) : (
                                <span style={{ color: "#F28C28", fontSize: "10px", fontWeight: "bold" }}>
                                  D{delay}
                                </span>
                              )}
                              {zones.map((z, i) => (
                                <div key={i} style={{ fontSize: "8px", color: "#333", whiteSpace: "nowrap" }}>
                                  P{z.panelNumber}-OZ{z.outputZoneIndex}
                                </div>
                              ))}
                            </div>
                          );
                        }


                        return (
                          <td
                            key={col.colId}
                            className="matrix-cell"
                            title={zonesTitle}
                            style={{
                              cursor: pendingCellKey === key ? "wait" : "pointer",
                              opacity: pendingCellKey === key ? 0.5 : 1,
                            }}
                            onClick={() => openCellDialog(row.rowId, col.colId, val)}
                            onContextMenu={(e) => handleCellRightClick2(e, row.rowId, col.colId)}
                          >
                            {display}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Menu
        open={Boolean(anchorPosition2)}
        onClose={() => setAnchorPosition2(null)}
        anchorReference="anchorPosition"
        anchorPosition={
          anchorPosition2
            ? { top: anchorPosition2.mouseY, left: anchorPosition2.mouseX }
            : undefined
        }
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={async () => {
            const { rowId, colId } = selectedCell2;
            const existing = cellConfig2[getCellKey2(rowId, colId)];
            setAnchorPosition2(null);
            await setCell(rowId, colId, {
              delaySeconds: 0,
              outputZones: existing?.outputZones || [],
            });
          }}
        >
          Immediate
        </MenuItem>

        <MenuItem
          onClick={() => {
            const { rowId, colId } = selectedCell2;
            setAnchorPosition2(null);
            openCellDialog(rowId, colId, cellConfig2[getCellKey2(rowId, colId)]);
          }}
        >
          Edit delay &amp; output zones...
        </MenuItem>

        <MenuItem
          onClick={async () => {
            const { rowId, colId } = selectedCell2;
            setAnchorPosition2(null);
            await setCell(rowId, colId, null);
          }}
        >
          Clear
        </MenuItem>
      </Menu>

      {showRowModal2 && (
        <div style={overlayStyle}>
          <div style={{ ...modalStyle, width: "340px" }}>
            <h5>{editingRowId2 ? "Edit Cause" : "Add Cause"}</h5>
            <TextField label="Cause" size="small" fullWidth multiline
              value={rowModal2Name} onChange={(e) => setRowModal2Name(e.target.value)} sx={{ mb: 2 }} />

            <FormControl size="small" fullWidth sx={{ mb: 2 }}>
              <InputLabel>Device type</InputLabel>
              <Select label="Device type" value={rowModal2Type}
                onChange={(e) => { setRowModal2Type(e.target.value); setRowModal2Count(""); }}>
                {causeMenu.map((m) => (
                  <MenuItem key={m.id} value={m.id}>{m.label} - {m.description}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" fullWidth sx={{ mb: 2 }} disabled={!rowModal2Type}>
              <InputLabel>Count</InputLabel>
              <Select label="Count" value={rowModal2Count} onChange={(e) => setRowModal2Count(e.target.value)}>
                {(causeMenu.find((m) => m.id === rowModal2Type)?.children || []).map((c) => (
                  <MenuItem key={c.id} value={c.id}>{c.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

           <TextField
  label={`Panel number (1-${MAX_PANEL_NUMBER})`}
  type="number"
  size="small"
  fullWidth
  inputProps={{ min: 1, max: MAX_PANEL_NUMBER, step: 1 }}
  value={rowModal2Panel}
  error={Boolean(rowPanelError)}
  helperText={rowPanelError}
  onChange={(e) => setRowModal2Panel(e.target.value)}
  sx={{ mb: 2 }}
/>
<TextField
  label={`Zone index (1-${MAX_ZONE_INDEX})`}
  type="number"
  size="small"
  fullWidth
  inputProps={{ min: 1, max: MAX_ZONE_INDEX, step: 1 }}
  value={rowModal2Zone}
  error={Boolean(rowZoneError)}
  helperText={rowZoneError}
  onChange={(e) => setRowModal2Zone(e.target.value)}
  sx={{ mb: 2 }}
/>
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
            <button
  className="add-btn"
  onClick={submitRowModal2}
  disabled={Boolean(rowPanelError || rowZoneError)}
  style={{ opacity: rowPanelError || rowZoneError ? 0.5 : 1 }}
>
  Save
</button>
              <button className="btn save" onClick={() => { setShowRowModal2(false); setEditingRowId2(null); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showColModal2 && (
        <div style={overlayStyle}>
          <div style={{ ...modalStyle, width: "340px" }}>
            <h5>{editingColId2 ? "Edit Effect" : "Add Effect"}</h5>
            <TextField
              label="Effect"
              size="small"
              fullWidth
              multiline
              value={colModal2Name}
              onChange={(e) => setColModal2Name(e.target.value)}
              sx={{ mb: 2 }}
            />
            {/* {VALUE_COL_COUNT_FIELDS.map((field) => (
              <div key={field} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                <label style={{ width: "120px", fontSize: "13px", fontWeight: "bold" }}> {COL_FIELD_LABELS[field]}</label>
                <input
                  type="number"
                  min="0"
                  value={colModal2Counts[field]}
                  onChange={(e) => setColModal2Counts((prev) => ({ ...prev, [field]: Number(e.target.value) || 0 }))}
                  style={{ width: "70px" }}
                />
              </div>
            ))} */}
            <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
              <button className="add-btn" onClick={submitColModal2}>
                Save
              </button>
              <button
                className="btn save"
                onClick={() => {
                  setShowColModal2(false);
                  setEditingColId2(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showPreviewPanel && previewResult && (
        <div style={overlayStyle}>
          <div style={{ ...modalStyle, width: "560px", maxHeight: "80vh", overflowY: "auto" }}>
            <h3>Preview: Matrix → Panel Generation</h3>
            <table style={{ width: "100%", fontSize: "13px", marginBottom: "12px" }}>
              <tbody>
                <tr>
                  <td>Panels required</td>
                  <td>
                    <strong>{previewResult.summary?.panelCount}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Value rows</td>
                  <td>{previewResult.summary?.valueRowCount}</td>
                </tr>
                <tr>
                  <td>Value columns</td>
                  <td>{previewResult.summary?.valueColumnCount}</td>
                </tr>
                <tr>
                  <td>Devices &amp; Modules</td>
                  <td>{previewResult.summary?.generatedDeviceAndModuleCount}</td>
                </tr>
                <tr>
                  <td>Zones</td>
                  <td>{previewResult.summary?.zoneCount}</td>
                </tr>
                <tr>
                  <td>Output Zones</td>
                  <td>{previewResult.summary?.outputZoneCount}</td>
                </tr>
                <tr>
                  <td>Logic Functions</td>
                  <td>{previewResult.summary?.logicFunctionCount}</td>
                </tr>
                <tr>
                  <td>Warnings</td>
                  <td style={{ color: previewResult.summary?.warningCount ? "red" : "inherit" }}>
                    {previewResult.summary?.warningCount}
                  </td>
                </tr>
              </tbody>
            </table>
            {previewResult.warnings?.length > 0 && (
              <div style={{ maxHeight: "140px", overflowY: "auto", marginBottom: "12px" }}>
                {previewResult.warnings.map((w, i) => (
                  <div
                    key={i}
                    style={{ fontSize: "12px", background: "Ivory", border: "1px solid #F4C430", padding: "6px", marginBottom: "4px" }}
                  >
                    <strong>[{String(w.type || "")}]</strong> {String(w.message || "")}
                  </div>
                ))}
              </div>
            )}
            <div style={{ display: "flex", gap: "10px" }}>
              <button className="add-btn" onClick={applyGeneration} disabled={applying}>
                {applying ? "Applying..." : "Confirm & Compile"}
              </button>
              <button className="btn save" onClick={() => setShowPreviewPanel(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showApplyResultPanel && applyResult && (
        <div style={overlayStyle}>
          <div style={{ ...modalStyle, width: "560px", maxHeight: "80vh", overflowY: "auto" }}>
            <h3>Panels Generated</h3>
            <p style={{ fontSize: "13px" }}>
              Replaced {applyResult.deletedOldPanelCount} old panel(s) with {applyResult.insertedNewPanelCount} new
              panel(s).
            </p>
            <table style={{ width: "100%", fontSize: "13px" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>Panel</th>
                  <th style={{ textAlign: "left" }}>Content ID</th>
                  <th style={{ textAlign: "left" }}>Device ID</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(applyResult.panelIdMap || {}).map(([num, p]) => (
                  <tr key={num}>
                    <td>{p.panelName || `Panel ${num}`}</td>
                    <td>{p.panelContent_id}</td>
                    <td>{p.panelDevice_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ marginTop: "12px" }}>
              <button className="btn save" onClick={() => setShowApplyResultPanel(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal open={showRowGroupModal2} onClose={() => setShowRowGroupModal2(false)}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, bgcolor: "background.paper",
            borderRadius: 2, boxShadow: 24, p: 3,
          }}>
          <Typography variant="h6" mb={2}>
            Edit Cause Group
          </Typography>
          <TextField fullWidth label="Group Name" value={rowModal2Name} onChange={(e) => setRowModal2Name(e.target.value)} />
          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setShowRowGroupModal2(false)}>Cancel</Button>
            <Button variant="contained" onClick={submitRowGroupModal2}> Save </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={showColumnGroupModal} onClose={() => setShowColumnGroupModal(false)}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: 400, bgcolor: "background.paper", borderRadius: 2, boxShadow: 24, p: 3,
        }}>
          <Typography variant="h6">Edit Column Group</Typography>
          <TextField fullWidth label="Group Name" margin="normal" value={columnModalName} onChange={(e) => setColumnModalName(e.target.value)} />
          <Box display="flex" justifyContent="flex-start" gap={1} mt={2}>
            <button className="add-btn" variant="contained" onClick={submitColumnGroupModal}>
              Save
            </button>
            <button className="cancel-btn" onClick={() => setShowColumnGroupModal(false)}>Cancel</button>
          </Box>
        </Box>
      </Modal>
      {showInfoPopup && (
        <div className="popup">
          <div className="popup-content">
            <h6>Project Information</h6>
            <input placeholder="Client Name" value={clientName} onChange={(e) => setClientName(e.target.value)} />
            <input placeholder="Consultant Name" value={consultantName} onChange={(e) => setConsultantName(e.target.value)} />
            <input placeholder="Main Contractor" value={mainContractor} onChange={(e) => setMainContractor(e.target.value)} />
            <input placeholder="MEP Contractor" value={mepContractor} onChange={(e) => setMepContractor(e.target.value)} />
            <input placeholder="FA Specialist Contractor"
              value={faSpecialistContractor} onChange={(e) => setFaSpecialistContractor(e.target.value)} />
            <div className="popup-actions">
              <button className="add-btn" onClick={handleSaveProjectInfo} disabled={savingProjectInfo}>{savingProjectInfo ? "Saving..." : "Save"}</button>
              <button className="cancel-btn" onClick={() => setShowInfoPopup(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      {/* for delete functionlaity  */}
      <Dialog open={deleteDialog.open}
        onClose={() => setDeleteDialog((prev) => ({ ...prev, open: false, }))}>
        <DialogTitle>{deleteDialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {deleteDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog((prev) => ({ ...prev, open: false, }))}>
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={applyDialogOpen} onClose={() => setApplyDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Apply Panel Generation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Applying will <strong>soft-delete all current Panels</strong> for this
            project and generate brand-new <strong>Panels, Devices, Zones, and Logic
              Functions</strong> from this Matrix.
            <br /><br />
            This operation cannot be undone from the UI.
            {syncState2 === "conflict" && (
              <>
                <br /><br />
                <strong style={{ color: "#b45309" }}>
                  Warning: the Matrix and Panel have both changed since the last sync. Applying now will use the
                  current Matrix as-is.
                </strong>
              </>
            )}
            <br /><br />
            <strong>Do you want to continue?</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn cancel" onClick={() => setApplyDialogOpen(false)}>Cancel</button>
          <button className="btn add" color="error" onClick={confirmApplyGeneration}
            disabled={applying}> {applying ? "Applying..." : "Apply"}</button>
        </DialogActions>
      </Dialog>

      <Modal open={addRowGroupModal.open} onClose={() => setAddRowGroupModal({ open: false, name: "", error: "" })}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: 400, bgcolor: "background.paper", borderRadius: 2, boxShadow: 24, p: 3,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add New Cause Group
          </Typography>
          <TextField
            fullWidth
            autoFocus
            label="Group Name"
            value={addRowGroupModal.name}
            onChange={(e) => setAddRowGroupModal((prev) => ({ ...prev, name: e.target.value, error: "" }))}
            error={Boolean(addRowGroupModal.error)}
            helperText={addRowGroupModal.error}
          />
          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setAddRowGroupModal({ open: false, name: "", error: "" })}>Cancel</Button>
            <Button variant="contained" onClick={confirmAddRowGroup2}>Add</Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={addColumnGroupModal.open} onClose={() => setAddColumnGroupModal({ open: false, name: "", error: "" })}>
        <Box
          sx={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: 400, bgcolor: "background.paper", borderRadius: 2, boxShadow: 24, p: 3,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add New Effect Group
          </Typography>
          <TextField
            fullWidth
            autoFocus
            label="Group Name"
            value={addColumnGroupModal.name}
            onChange={(e) => setAddColumnGroupModal((prev) => ({ ...prev, name: e.target.value, error: "" }))}
            error={Boolean(addColumnGroupModal.error)}
            helperText={addColumnGroupModal.error}
          />
          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setAddColumnGroupModal({ open: false, name: "", error: "" })}>Cancel</Button>
            <Button variant="contained" onClick={confirmAddColumnGroup2}>Add</Button>
          </Box>
        </Box>
      </Modal>


      <Dialog open={cellDialog.open} onClose={closeCellDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Cell settings</DialogTitle>
        <DialogContent>
          <TextField
            label="Delay (seconds, 0 = immediate)"
            type="number"
            size="small"
            fullWidth
            inputProps={{ min: 0 }}
            value={cellDialog.delay}
            onChange={(e) => setCellDialog((p) => ({ ...p, delay: e.target.value }))}
            sx={{ mt: 1, mb: 2 }}
          />

          <Typography variant="subtitle2" sx={{ mb: 1 }}>Output zones</Typography>
     {cellDialog.groups.map((g, i) => {
  const zoneError = validateZonesText(g.zonesText);
  const panelNum = Number(g.panelNumber);
  const panelError =
    g.panelNumber !== "" && (!Number.isInteger(panelNum) || panelNum < 1 || panelNum > 32);

  return (
    <Box key={i} display="flex" gap={1} mb={1} alignItems="flex-start">
      <TextField
        label="Panel"
        type="number"
        size="small"
        sx={{ width: 90 }}
        inputProps={{ min: 1, max: 32 }}
        value={g.panelNumber}
        error={panelError}
        helperText={panelError ? "1-32" : ""}
        onChange={(e) => updateGroup(i, "panelNumber", e.target.value)}
      />
      <TextField
        label={`Output zones (1-${MAX_OUTPUT_ZONE}, e.g. 1,2,5-8)`}
        size="small"
        fullWidth
        value={g.zonesText}
        error={Boolean(zoneError)}
        helperText={zoneError}
        onChange={(e) =>
          // keep only digits, commas, dashes and spaces
          updateGroup(i, "zonesText", e.target.value.replace(/[^0-9,\-\s]/g, ""))
        }
      />
      <Button color="error" onClick={() => removeZone(i)}>✕</Button>
    </Box>
  );
})}
          <Button size="small" onClick={addZone}>+ Add output zone</Button>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={clearCellFromDialog}>Clear cell</Button>
          <Button onClick={closeCellDialog}>Cancel</Button>
         <Button variant="contained" onClick={saveCellDialog} disabled={cellDialogHasError}>
  Save
</Button>
        </DialogActions>
      </Dialog>

    </>
  );
};
export default CloudProMatrixToPanel;
